import classNames from 'classnames';
import React, { FC } from 'react';
type OwnProps = {
    className?: any;
    fillColor?: any;
    pathStrokeColor?: any;
    pathFillColor?: any;
};
type SVGPermitProps = OwnProps;

const SVGPermit: FC<SVGPermitProps> = (props) => {
    const { fillColor, pathStrokeColor, pathFillColor, className } = props;
    return (
        <svg
            width="46"
            height="36"
            viewBox="0 0 46 36"
            fill={fillColor ?? 'none'}
            xmlns="http://www.w3.org/2000/svg"
            className={classNames(className)}
        >
            <path
                d="M14.6381 0.22757H2.09281C0.938026 0.22757 0.00195312 1.16364 0.00195312 2.31843V14.8637C0.00195312 16.0185 0.938026 16.9545 2.09281 16.9545H14.6381C15.7928 16.9545 16.7289 16.0185 16.7289 14.8637V2.31843C16.7289 1.16364 15.7928 0.22757 14.6381 0.22757ZM12.5472 12.7728H4.18367V4.40929H12.5472V12.7728Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
            <path
                d="M43.9093 6.50015H23.0005C21.8457 6.50015 20.9097 7.43623 20.9097 8.59101C20.9097 9.7458 21.8457 10.6819 23.0005 10.6819H43.9093C45.0641 10.6819 46.0002 9.7458 46.0002 8.59101C46.0002 7.43632 45.064 6.50015 43.9093 6.50015Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
            <path
                d="M43.9093 27.4089H23.0005C21.8457 27.4089 20.9097 28.3451 20.9097 29.4998C20.9097 30.6545 21.8457 31.5907 23.0005 31.5907H43.9093C45.0641 31.5907 46.0002 30.6545 46.0002 29.4998C46.0002 28.3451 45.064 27.4089 43.9093 27.4089Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
            <path
                d="M13.1732 23.8314L6.21274 30.7084L3.59497 27.9903C2.79185 27.16 1.46771 27.1379 0.637411 27.9411C-0.192883 28.7442 -0.21489 30.0683 0.588235 30.8986L4.67377 35.1452C5.06338 35.5427 5.59545 35.7685 6.15206 35.7725H6.17714C6.72533 35.7707 7.25097 35.5537 7.64075 35.1682L16.1005 26.8047C16.9757 26.0514 17.0746 24.7312 16.3214 23.856C15.5681 22.9808 14.2479 22.8819 13.3727 23.6351C13.3019 23.696 13.2353 23.7616 13.1732 23.8314Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
        </svg>
    );
};

export default SVGPermit;
